import axios from 'axios';

export default (document_id) => axios.delete(`${process.env.VUE_APP_API_ENDPOINT}/document-manager/${document_id}`);
